/** Defense in depth around backend-validated playback responses. */
export function isSafePlaybackUrl(value: string, pageUrl: string, allowedHosts = "archive.org,*.archive.org"): boolean {
  try {
    const page = new URL(pageUrl);
    const url = new URL(value, page);
    if (url.username || url.password) return false;
    const generatedPath = /^\/v1\/advertising\/assets\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/[1-9]\d{0,2}\/spot\.(mp4|vtt)$/i;
    if (url.protocol === "https:" && url.origin === page.origin && generatedPath.test(url.pathname) && !url.search && !url.hash) return true;
    if (url.protocol === "https:") {
      const host = url.hostname.toLowerCase();
      return allowedHosts.split(",").map((pattern) => pattern.trim().toLowerCase()).filter(Boolean).some((pattern) => {
        const normalized = pattern.replace(/^\*\./, "");
        return pattern.startsWith("*.") ? host.endsWith(`.${normalized}`) && host !== normalized : host === normalized;
      });
    }
    return url.protocol === "http:" && ["localhost", "127.0.0.1", "[::1]"].includes(page.hostname)
      && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
  } catch { return false; }
}
